import React, { ReactNode, MouseEvent } from 'react';
import './Button.scss';

// Define types for button variants
type ButtonType = 'primary' | 'secondary' | 'tertiary' | 'blue' | 'darkTertiary';
type ButtonSize = 'small' | 'medium' | 'large';

// Define component props interface
interface ButtonProps {
  children: ReactNode;
  type?: ButtonType;
  size?: ButtonSize;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  style?: React.CSSProperties;
  className?: string;
  fullWidth?: boolean;
  icon?: React.ReactElement;
  [key: string]: any;
}

const Button: React.FC<ButtonProps> = ({
  children,
  type = 'primary',
  size = 'medium',
  onClick,
  disabled = false,
  style = {},
  className = '',
  icon,
  fullWidth = false,
  ...restProps
}) => {
  // Build BEM class names based on props
  const buttonClasses = [
    'ap-button',
    `ap-button--${type}`,
    `ap-button--${size}`,
    fullWidth ? 'ap-button--full-width' : '',
    disabled ? 'ap-button--disabled' : '',
    className
  ].filter(Boolean).join(' ');

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    if (!disabled && onClick) {
      onClick(event);
    }
  };

  return (
    <button
      type="button"
      className={buttonClasses}
      onClick={handleClick}
      disabled={disabled}
      style={style}
      {...restProps}
    >
      <span className="ap-button__content">
        {children}
        {icon && (
          <span className={`ap-button__icon ap-button__icon--${size}`}>
            {icon}
          </span>
        )}
      </span>
    </button>
  );
};

export default Button;